<template>
  <path
    :style="{ fill: iconColor }"
    d="M 0 7 L 0 22 A 1.0001 1.0001 0 1 0 2 22 L 2 14.152344 C 3.3954211 15.368609 8.2491142 19.599535 13.298828 24 L 16.335938 24 C 10.510343 18.922159 2.2713258 11.742332 2 11.505859 L 2 9 L 48 9 L 48 11.507812 C 47.575803 11.877552 29.817251 27.354929 28.335938 28.644531 C 26.927937 29.870531 25.534 30.001953 25 30.001953 C 24.984 30.001953 24.959406 30 24.941406 30 L 20.183594 30 C 20.251594 30.059 20.311516 30.110484 20.353516 30.146484 C 22.271516 31.816484 24.241047 31.998047 24.998047 31.998047 C 25.757047 31.998047 27.727531 31.818438 29.644531 30.148438 C 29.923072 29.905946 32.12268 27.988199 33.341797 26.925781 L 48 38.513672 L 48 41 L 16 41 A 1.0001 1.0001 0 1 0 16 43 L 50 43 L 50 7 L 0 7 z M 48 14.150391 L 48 35.964844 L 34.876953 25.587891 C 40.117657 21.020531 46.258619 15.668213 48 14.150391 z M 1 25.988281 A 1.011719 1.011719 0 1 0 1 28.011719 L 20 28.011719 A 1.011719 1.011719 0 0 0 20 25.988281 L 1 25.988281 z M 1 30.988281 A 1.011719 1.011719 0 1 0 1 33.011719 L 16 33.011719 A 1.011719 1.011719 0 0 0 16 30.988281 L 1 30.988281 z M 1 35.988281 A 1.011719 1.011719 0 1 0 1 38.011719 L 13 38.011719 A 1.011719 1.011719 0 0 0 13 35.988281 L 1 35.988281 z M 1 40.988281 A 1.011719 1.011719 0 1 0 1 43.011719 L 10 43.011719 A 1.011719 1.011719 0 0 0 10 40.988281 L 1 40.988281 z"
  />
</template>

<script>
export default {
    name: 'MailIcon',
    props: {
        iconColor: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped></style>
